<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Olá! Na aba UNIDADES PARTICIPANTES você pode analisar cada unidade da
        estrutura organizacional.
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No filtro <b>“Selecione a unidade”</b>, posicionado do lado direito,
          você seleciona a unidade organizacional que deseja verificar; após
          efetuar essa escolha aparecerão gráficos e tabelas com dados
          referentes a composição da equipe da unidade selecionada.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na tabela é possível observar a relação dos servidores da unidade;
          utilizar os recursos de ordenação, de forma crescente ou decrescente,
          por nome do servidor, cargo ou função, bem como, realizar pesquisa por
          qualquer termo constante na tabela.
        </p>
      </div>
    </div>

    <div>
      <h2>Importante!</h2>
      <div class="mx-2 pa-2 justify-center">
        <ul>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Sugere-se observar a equipe que compõe a unidade, os cargos e as
              funções. Caso haja alguma inconsistência na lotação dos
              servidores, recomenda-se procurar a PROGEP.
            </p>
          </li>
        </ul>
      </div>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../../BaseTutorial';

export default {
  name: 'TutorialMonitoramentoMapeamentoEstruturaUnidades',

  components: { BaseTutorial },

  data() {
    return {
      steps: ['Introdução', 'Importante'],
    };
  },
};
</script>
